import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Button, Card, Container } from "react-bootstrap";
import _ from "lodash";
import html2pdf from "html2pdf.js";
import ReactToPrint from "react-to-print";

import Barcode from "react-barcode";
import { QRCodeSVG } from "qrcode.react";

import ApiBasketItemPerson from "../../../../../core/api/api.basketItemPerson";
import { useParams, useSearchParams } from "react-router-dom";
import SplitNumber from "../../../_Components/SplitNumber";

import { IconErrorCircle } from "../../../../../_metronic/css/icons";
import { Link } from "react-router-dom";
import DottedLoadingData from "../../../_Components/DottedLoadingData";

// const PrintComponent = React.forwardRef((props, ref) => (
//   <div ref={ref}>
//     <h1>Hello World!</h1>
//     <p>This content will be converted to PDF and printed.</p>
//   </div>
// ));

class ComponentToPrint extends React.Component {
  render() {
    const { ticket } = this.props;
    ///ایجاد متن برای قسمت برنامه و سانس
    const showReserveItemGroupTitleInTicketPlan =
      ticket?.amusementServiceReserveItem?.showReserveItemGroupTitleInTicketPlan;
    const showReserveItemTitleInTicketPlan =
      ticket?.amusementServiceReserveItem?.showReserveItemTitleInTicketPlan;
    const ticketPlanDetail =
      ticket?.amusementServiceReserveItem?.ticketPlanDetail;

    const textTitleGroupTicket = [
      showReserveItemGroupTitleInTicketPlan &&
      ticket?.amusementServiceReserveItemGroupTitle,
      showReserveItemTitleInTicketPlan &&
      ticket?.amusementServiceReserveItem.title,
      ticketPlanDetail && ticket?.amusementServiceReserveItem.ticketPlanDetail,
    ].filter(Boolean);

    function formatTimeSpan(timeSpan) {
      if (_.isEmpty(timeSpan)) {
        return "-";
      }
      const [hours, minutes] = timeSpan.split(":");
      return `${hours}:${minutes}`;
    }
    return (
      <div
        className="rtl line-height-2 overflow-hidden"
        // style={{ width: "210mm" }}
        id="content-to-print"
      >
        <div className="text-end position-relative">
          {!!ticket?.amusementServiceReserveItem?.reference && (
            <div className="text-start position-absolute start-0 pt-2">
              رفرنس :{" "}
              <span className="font-latin">
                {ticket?.amusementServiceReserveItem?.reference}
              </span>
            </div>
          )}
          <div className="d-flex justify-content-end pt-3 ">
            <div className="border-start d-flex justify-content-center flex-column align-items-center px-3">
              <img
                src="/media/logos/logo-s1.png"
                alt="logo"
                className="mb-2"
                width="80px"
              />
              {/* <div className="fs-065">پشتیبانی</div> */}
              <div className="fs-09">09199781891</div>
              <div className="fs-09">076-44100000</div>
              <div className="fs-09">09193373894</div>
            </div>
            <div className="px-3 pt-3">
              <Row>
                <Col xs="12">
                  <div className="text-orange fw-bold fs-102">
                    {ticket.isEvent ? ticket.hallEventTitle : ticket.amusementServiceName}
                  </div>
                </Col>
                <Col xs="6">
                  <div className="fs-09">
                    <span className="text-black-06 me-1">نام مهمان :</span>
                    <span className="fw-bold">
                      {" "}
                      {ticket.basketPersonFullName}
                    </span>
                  </div>
                </Col>
                <Col xs="6">
                  <div className="fs-09">
                    <span className="text-black-06 me-1">تلفن همراه :</span>
                    <span className="fw-bold">{ticket.basketMobile} </span>
                  </div>
                </Col>
                <Col xs="6">
                  <div className="fs-09">
                    <span className="text-black-06 me-1">تاریخ اجرا :</span>
                    <span className="fw-bold">{ticket.checkInDate} </span>
                  </div>
                </Col>
                <Col xs="6">
                  <div className="fs-09">
                    <span className="text-black-06 me-1">زمان اجرا :</span>
                    <span className="fw-bold">
                      {formatTimeSpan(
                        ticket.isEvent ? ticket.hallEventExecutionTime : ticket.amusementServiceReserveItem?.executionTime
                      )}
                    </span>
                  </div>
                </Col>
                <Col xs={ticket.isEvent ? "6" : "12"}>
                  {!ticket.isEvent && <div className="fs-09 d-flex">
                    <span className="text-black-06 me-1">برنامه و سانس :</span>
                    <span className="fw-bold d-flex">
                      {textTitleGroupTicket.map((html, index) => (
                        <span key={index}>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: html,
                            }}
                          />
                          {index < textTitleGroupTicket.length - 1 && " - "}
                        </span>
                      ))}
                      {/* {ticket.amusementServiceReserveItem
                        .showReserveItemGroupTitleInTicketPlan === true && (
                        <span>
                          {ticket.amusementServiceReserveItemGroupTitle}
                        </span>
                      )}
                      {ticket.amusementServiceReserveItem
                        .showReserveItemTitleInTicketPlan === true && (
                        <span>{ticket.amusementServiceReserveItem?.title}</span>
                      )}
                      {ticket.ticketPlanDetail !== null && (
                        <span
                          dangerouslySetInnerHTML={{
                            __html:
                              ticket.amusementServiceReserveItem
                                ?.ticketPlanDetail,
                          }}
                        ></span>
                      )} */}
                    </span>
                  </div>}
                  {ticket.isEvent &&
                    <div className="fs-09 d-flex">
                      <span className="text-black-06 me-1">نام سالن: </span>
                      <span className="fw-bold">{ticket.hallName}</span>
                    </div>
                  }
                </Col>
                {ticket.isEvent && <Col xs="6">
                  <div className="fs-09 d-flex">
                    <span className="text-black-06 me-1">آدرس سالن: </span>
                    <span className="fw-bold">{ticket.hallAddress}</span>
                  </div>
                </Col>}
              </Row>
            </div>
          </div>
        </div>
        <div className="border-top pt-3 mt-3"></div>
        <div>
          <Row className="fs-09">
            {!!ticket.amusementServiceReserveItem?.ticketRules && (
              <Col xs="6">
                <div className="fw-bold">
                  قوانین {ticket.amusementServiceName}
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: ticket.amusementServiceReserveItem?.ticketRules,
                  }}
                />
              </Col>
            )}
            {!!ticket?.hallRegulations && (
              <Col xs="6">
                <div className="fw-bold">
                  قوانین {ticket.hallEventTitle}
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: ticket?.hallRegulations,
                  }}
                />
              </Col>
            )}
            {!!ticket.amusementServiceReserveItem?.ticketDescription && (
              <Col xs="6">
                <div className="fw-bold">توضیحات برنامه</div>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      ticket.amusementServiceReserveItem?.ticketDescription,
                  }}
                />
              </Col>
            )}
          </Row>
        </div>
        {ticket.amusementServiceReserveItem?.ticketDescription === null &&
          ticket.amusementServiceReserveItem?.ticketRules === null ? (
          ""
        ) : (
          <div
            className=" pt-5 mt-3"
            style={{ borderTop: "1px dashed #888" }}
          ></div>
        )}
        {ticket?.basketItemPersons?.map((item) => (
          <Col xs="12" className="border border-dark rounded-4 fs-09  bg-white mb-5">
            <Row style={{ borderRight: "12px solid #f76900db" }} className={`gx-0 rounded-end-4 ${!!item.ticketSourceId && item.ticketSourceBarcode.length > 20 ? "flex-column" : ""}`}>
              <Col >
                <Row className="py-2 px-3 h-100">
                  <Col xs="6">
                    <span className="text-black-06 me-1">نام مهمان : </span>
                    <span className="fw-bold">{item.personFullName}</span>
                  </Col>
                  <Col xs="6">
                    <span className="text-black-06 me-1"> قیمت : </span>
                    <span className="fw-bold">
                      <SplitNumber number={item.originalPrice} /> تومان{" "}
                    </span>
                  </Col>
                  {ticket.isEvent ? <Col xs="12" className="d-flex">
                    <span className="text-black-06 me-1 flex-shrink-0">صندلی : </span>
                    <span className="fw-bold ticket-dec me-2">
                      جایگاه: {item.hallBlockName} - ردیف: {item.hallRowName} - صندلی: {item.hallSeatName}
                    </span>
                  </Col>
                    : <Col xs="12" className="d-flex">
                      <span className="text-black-06 me-1 flex-shrink-0">برنامه و سانس : </span>
                      <span className="fw-bold ticket-dec me-2">
                        {textTitleGroupTicket.map((html, index) => (
                          <span key={index}>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: html,
                              }}
                            />
                            {index < textTitleGroupTicket.length - 1 && " - "}
                          </span>
                        ))}
                        {/* {ticket.amusementServiceReserveItem
                        .showReserveItemGroupTitleInTicketPlan === true && (
                        <span>
                          {ticket.amusementServiceReserveItemGroupTitle} -
                        </span>
                      )}
                      {ticket.amusementServiceReserveItem
                        .showReserveItemTitleInTicketPlan === true && (
                        <span>
                          {ticket.amusementServiceReserveItem?.title} -{" "}
                        </span>
                      )}
                      {ticket.ticketPlanDetail !== null && (
                        <span
                          dangerouslySetInnerHTML={{
                            __html:
                              ticket.amusementServiceReserveItem
                                ?.ticketPlanDetail,
                          }}
                        ></span>
                      )} */}
                      </span>
                    </Col>}
                </Row>
              </Col>
              <Col
                className={`${!!item.ticketSourceId && item.ticketSourceBarcode.length > 20 ? "pdf-ticket-cut-row w-100" : "pdf-ticket-cut"} position-relative`}
                xs={!!item.ticketSourceId && item.ticketSourceBarcode.length > 20 ? "12" : "auto"}
                style={{ borderBottom: !!item.ticketSourceId && item.ticketSourceBarcode.length > 20 ? "1px dashed #444" : "none", borderRight: (!item.ticketSourceId || (!!item.ticketSourceId && item.ticketSourceBarcode.length <= 20)) ? "1px dashed #444" : "none", zIndex: 11 }}
              >
                <div className="top"></div>
                <div className="bottom"></div>
              </Col>
              <Col
                xs="auto"
                className="text-end d-flex flex-row justify-content-end p-2"
              >
                {(!!item.ticketSourceId) ?
                  <>
                    <div className="text-center d-flex flex-column justify-content-center px-3 barCode-div">
                      {(!!item.ticketSourceNumber || !!item.ticketSourceBarcode) &&
                        <Barcode
                          value={!!item.ticketSourceBarcode ? item.ticketSourceBarcode : item.ticketSourceNumber}
                          width={1.2}
                          height={30}
                          displayValue={false}
                        />}
                      {!!item.ticketSourceNumber && <div className="font-latin fs-101">{item.ticketSourceNumber}</div>}
                    </div>
                    {(!!item.ticketSourceNumber || !!item.ticketSourceQRCode) &&
                      <div className="qrCode-div">
                        <QRCodeSVG value={!!item.ticketSourceQRCode ? item.ticketSourceQRCode : item.ticketSourceNumber} size={70} />
                      </div>
                    }
                  </>
                  : <>
                    <div className="text-center px-3 barCode-div">
                      <Barcode
                        value={item.id}
                        width={1.2}
                        height={30}
                        displayValue={false}
                      />
                      <div className="font-latin fs-101">{item.id}</div>{" "}
                    </div>
                    <div className="qrCode-div">
                      <QRCodeSVG value={item.id} size={70} />
                    </div>
                  </>
                }
              </Col>
            </Row>
          </Col>
        ))}
      </div>
    );
  }
}
function Ticket() {
  const { id } = useParams();
  const [searchParams] = useSearchParams(); // برای خواندن کوئری‌استرینگ
  const [ticket, setTicket] = useState({});
  const [showMsg, setShowMsg] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    (async () => {
      const mode = searchParams.get("q");

      const result = await ApiBasketItemPerson.getTicket(id);
      console.log("result=", result);
      if (result.succeeded == false) {
        setLoadingData(false);
        setShowMsg(true);
        return;
      }
      setTicket(result.data);
      setShowMsg(false);
      setLoadingData(false);
    })();
  }, []);

  const generatePDF = () => {
    const element = document.getElementById("content-to-print");
    const options = {
      margin: [5, 5],
      filename: "documentw.pdf",
      image: { type: "jpg", quality: 0.9 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(options).from(element).save();
  };
  const componentRef = useRef();

  return (
    <>
      {loadingData ? (
        <Container className="mt-5">
          <DottedLoadingData />
        </Container>
      ) : showMsg ? (
        <Container
          className="d-flex align-items-center justify-content-between"
          style={{ minHeight: "400px" }}
        >
          <Card className="mx-auto border-0 rounded-4 shadow-sm text-center">
            <Card.Header
              className=" very-large-icons border-bottom-0 rounded-top-4 pt-3 pb-4"
              style={{ background: "#f9e3e8" }}
            >
              <IconErrorCircle fillColor="red" />
              <div className="text-danger fw-bold fs-103 mt-2">
                لینک نامعتبر{" "}
              </div>
              <div className="text-danger mt-1 fs-08">
                لینک بلیط معتبر نمی باشد{" "}
              </div>
            </Card.Header>
            <Card.Body className="line-height-2">
              لینکی که وارد کرده اید وجود ندارد . لطفا از درستی لینک اطمینان
              حاصل کنید.
              <br /> در صورت نیاز به راهنمایی، با پشتیبانی تماس بگیرید.{" "}
            </Card.Body>
            {/* <Card.Footer className="border-top-0 rounded-bottom-4 py-3 bg-light">
              <Link to="/contact">
                <Button
                  className="px-4 fs-085 rounded-pill"
                  variant="outline-danger"
                >
                  تماس با پشتیبانی{" "}
                </Button>
              </Link>
            </Card.Footer> */}
          </Card>
        </Container>
      ) : ticket?.basketItemPersons?.length > 0 ? (
        <div className="main-content">
          <div className=" mx-auto" style={{ width: "210mm" }}>
            <ReactToPrint
              trigger={() => (
                <Button variant="primary" className="fs-085  px-5 py-2">
                  چاپ بلیط
                </Button>
              )}
              content={() => componentRef.current}
              pageStyle={`
              @page {
                margin: 0;
              }
          
              @media print {
                html, body {
                  margin: 0 !important;
                  padding: 0 !important;
                  height: 100% !important;
                }
          
                #print-section {
                  margin: 0 !important;
                  padding: 0 !important;
                  position: absolute !important;
                  top: 0 !important;
                  left: 0 !important;
                }
              }
            `}
            />
            <Button
              variant="info"
              className="fs-085 px-5 py-2 me-2"
              onClick={generatePDF}
            >
              دانلود فایل بلیط
            </Button>
          </div>
          <div
            className="mt-3 px-2 border rounded-4 bg-white pb-3 mx-auto"
            style={{ width: "210mm" }}
          >
            <ComponentToPrint ref={componentRef} ticket={ticket} />
          </div>
        </div>
      ) : (
        <Container
          className="d-flex align-items-center justify-content-between"
          style={{ minHeight: "400px" }}
        >
          <Card className="mx-auto border-0 rounded-4 shadow-sm text-center">
            <Card.Header
              className=" very-large-icons border-bottom-0 rounded-top-4 pt-3 pb-4"
              style={{ background: "#f9e3e8" }}
            >
              <IconErrorCircle fillColor="red" />
              <div className="text-danger fw-bold fs-103 mt-2">
                عدم نمایش بلیط
              </div>
              <div className="text-danger mt-1 fs-08">
                آیتم ها قابل نمایش نیستند.{" "}
              </div>
            </Card.Header>
            <Card.Body className="line-height-2">
              با توجه به اینکه بلیط ها معتبر نیستند، امکان دانلود آنها وجود
              ندارد.
              <br /> در صورت نیاز به تهیه بلیط جدید، لطفا مجددا اقدام به خرید
              نمایید.{" "}
            </Card.Body>
            <Card.Footer className="border-top-0 rounded-bottom-4 py-3 bg-light">
              <Link to="/tourism">
                <Button
                  className="px-4 fs-085 rounded-pill"
                  variant="outline-danger"
                >
                  بازگشت به صفحه اصلی{" "}
                </Button>
              </Link>
            </Card.Footer>
          </Card>
        </Container>
      )}
    </>
  );
}
export default Ticket;
